import React from 'react';

export const TitleAndValue: React.FC<TitleAndValueProps> = ({ titleValueData, textSize = 'lg' }) => {
  return (
    <>
      {titleValueData.map(({ title, valueAsString, AddedComponent, suffix }, index) => (
        <div key={index} className="space-y-1 ">
          <p className="text-gray-600 text-sm whitespace-nowrap">{title}</p>
          <div className="flex flex-row">
            <p className={`text-${textSize} whitespace-nowrap truncate`} title={valueAsString}>
              {valueAsString}
              {suffix && <span className="text-sm">{suffix}</span>}
            </p>
            {AddedComponent && <AddedComponent />}
          </div>
        </div>
      ))}
    </>
  );
};
interface TitleAndValueProps {
  titleValueData: { title: string; valueAsString: string; suffix?: string; AddedComponent?: React.ElementType }[];
  textSize?: 'lg' | 'md' | 'sm';
}
